import { render, staticRenderFns } from "./CategoryCompare.vue?vue&type=template&id=f72cce3c&scoped=true&"
import script from "./CategoryCompare.vue?vue&type=script&lang=js&"
export * from "./CategoryCompare.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCompare.vue?vue&type=style&index=0&id=f72cce3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72cce3c",
  null
  
)

export default component.exports